import React from "react"
import { useSelector } from "react-redux"

export default function AuthGuard({ children, placeholder }) {
  const { authenticated } = useSelector((state) => state.app)
  const { entry: profile } = useSelector((state) => state.profile)

  if (authenticated && profile.email) return <>{children}</>

  if (placeholder) return placeholder

  return false
}
